var __jsx = React.createElement;
import React from "react";
import { useCarCompareContext } from "@/_MiniApps/CarCompare/CarCompare";
import { twMerge } from "tailwind-merge";
import { useTranslation } from "@i18n";
import stl from "../CarCompare.module.css";
var AddCarToCompare = function AddCarToCompare(_ref) {
  var car = _ref.car,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className;
  var _useTranslation = useTranslation(["web_common"]),
    t = _useTranslation.t;
  var _useCarCompareContext = useCarCompareContext(),
    bigData = _useCarCompareContext.bigData,
    isAddCarAllowed = _useCarCompareContext.isAddCarAllowed,
    isCarIncluded = _useCarCompareContext.isCarIncluded,
    removeCar = _useCarCompareContext.removeCar,
    addCar = _useCarCompareContext.addCar,
    stopOverLay = _useCarCompareContext.stopOverLay;
  if (!isAddCarAllowed() || !(bigData !== null && bigData !== void 0 && bigData.showComparison)) return null;
  return /*#__PURE__*/React.createElement("div", {
    id: "posts-card-compare-btn-".concat(car === null || car === void 0 ? void 0 : car.id),
    className: twMerge("highlightme relative gap-1  flex items-center justify-start border-t border-[#E9E9E9] bg-transparent p-3 cursor-pointer", className),
    style: {
      borderTopStyle: "solid",
      backgroundColor: "#fff"
    },
    onClick: function onClick() {
      isCarIncluded(parseInt(car.id, 10)) ? removeCar(parseInt(car.id, 10)) : addCar(car);
      stopOverLay();
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: ["flex items-center justify-center", stl.checkBox, isCarIncluded(parseInt(car.id, 10)) ? stl.checkBoxIncluded : bigData.maxCars === bigData.cars.length ? stl.disableCheckBoxEmpty : stl.checkBoxEmpty].join(" "),
    id: !isCarIncluded(parseInt(car.id, 10)) ? "compare-checkbox-empty" : undefined
  }), /*#__PURE__*/React.createElement("span", {
    id: "compare-filter-checkbox",
    className: [bigData.maxCars === bigData.cars.length && !isCarIncluded(parseInt(car.id, 10)) ? "text-[#C0C0C0]" : "text-[#3C56D4]", "text-xs font-bold leading-6"].join(" ")
  }, t("قارن هذه السيارة", {
    ns: "web_sell_trade"
  })));
};
export default AddCarToCompare;